(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("3uZKH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "makeContentId", function () { return $28c413232e8985e3$export$a79dfe7cc032d910; });
$parcel$export(module.exports, "makeContainerId", function () { return $28c413232e8985e3$export$ee5ed2552be15682; });
$parcel$export(module.exports, "SectionPlaceholder", function () { return $28c413232e8985e3$export$c6db4598569fead5; });
$parcel$export(module.exports, "make", function () { return $28c413232e8985e3$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $28c413232e8985e3$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $28c413232e8985e3$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $hfCPd = parcelRequire("hfCPd");

var $1xf0g = parcelRequire("1xf0g");

var $dMhWy = parcelRequire("dMhWy");

var $jAQD1 = parcelRequire("jAQD1");

var $3gZOF = parcelRequire("3gZOF");

var $hhx0n = parcelRequire("hhx0n");

var $1SJOO = parcelRequire("1SJOO");

var $ePRCc = parcelRequire("ePRCc");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $44tgL = parcelRequire("44tgL");

var $hBcYV = parcelRequire("hBcYV");

var $e1Nsu = parcelRequire("e1Nsu");

var $hP9EI = parcelRequire("hP9EI");

var $dtaxl = parcelRequire("dtaxl");

var $d9SaG = parcelRequire("d9SaG");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");

var $7MOac = parcelRequire("7MOac");

var $6EwcS = parcelRequire("6EwcS");
function $28c413232e8985e3$export$a79dfe7cc032d910(id) {
    return "sn-section-content-" + id;
}
function $28c413232e8985e3$export$ee5ed2552be15682(id) {
    return "sn-section-container-" + id;
}
function $28c413232e8985e3$var$SectionContent$SectionPlaceholder(Props) {
    var anchorHookResult = Props.anchorHookResult;
    var category = Props.category;
    var match = $aSJcu.use(undefined);
    var windowWidth = match.windowSize.width;
    $8E2YL.use(undefined);
    var theme = $ePRCc.useLocalTheme(undefined);
    var containerWidth = $2whNH.mapWithDefault($1xf0g.Layout.getMaxWidth(category.userSelectedLayout), windowWidth, function(maxWidth) {
        return Math.min(windowWidth, maxWidth);
    });
    var match$1 = $diVVk.Size.estimateSectionSize(containerWidth, /* Slider */ 0, $1xf0g.calculateGridColumns(category.card), $1xf0g.CategoryCard.getCardSize(undefined, category.card), $1xf0g.CategoryCard.getCardShape(undefined, undefined, category.card), $1xf0g.getChildren(category).length, theme);
    var height = match$1[1] + (category.showTitle ? 80 : 0) | 0;
    $3gZOF.useDelayedRegister(anchorHookResult, category);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-hidden": true,
        "aria-label": category.title,
        className: $ezf3v.prefix("pt-row-custom-half pb-row-custom-half"),
        id: "sn-section-container-" + category.id,
        role: "region",
        style: {
            height: $ezf3v.intToPx(height)
        }
    });
}
$28c413232e8985e3$var$SectionContent$SectionPlaceholder.displayName = "SectionContent.SectionPlaceholder";
var $28c413232e8985e3$export$c6db4598569fead5 = {
    make: $28c413232e8985e3$var$SectionContent$SectionPlaceholder
};
function $28c413232e8985e3$var$SectionContent(Props) {
    var children = Props.children;
    var index = Props.index;
    var preferredContentType = Props.preferredContentType;
    var shouldShowHeaderOpt = Props.shouldShowHeader;
    var shouldShowBackToTopButtonOpt = Props.shouldShowBackToTopButton;
    var isZoomEnabledOpt = Props.isZoomEnabled;
    var applyVisibleInParentOpt = Props.applyVisibleInParent;
    var applyVisibleInHeaderOpt = Props.applyVisibleInHeader;
    var category = Props.category;
    var refreshUserSavedProductsOpt = Props.refreshUserSavedProducts;
    var parentCategory = Props.parentCategory;
    var layout = Props.layout;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var forcedShape = Props.forcedShape;
    var forcedSize = Props.forcedSize;
    var forcedOpenLinkOpt = Props.forcedOpenLink;
    var enableSmartCard = Props.enableSmartCard;
    var enableFirstCard = Props.enableFirstCard;
    var enableLastCard = Props.enableLastCard;
    var enableInlineMedia = Props.enableInlineMedia;
    var isPaddingEnabledOpt = Props.isPaddingEnabled;
    var isThemeEnabledOpt = Props.isThemeEnabled;
    var shouldCenterSlides = Props.shouldCenterSlides;
    var hideRelatedProductId = Props.hideRelatedProductId;
    var priority = Props.priority;
    var anchorHookResult = Props.anchorHookResult;
    var overrideTabSettings = Props.overrideTabSettings;
    var layoutControllerHookOpt = Props.layoutControllerHook;
    var className = Props.className;
    var customTitle = Props.customTitle;
    var onTitleClick = Props.onTitleClick;
    var onLinkClick = Props.onLinkClick;
    var shouldShowHeader = shouldShowHeaderOpt !== undefined ? shouldShowHeaderOpt : true;
    var shouldShowBackToTopButton = shouldShowBackToTopButtonOpt !== undefined ? shouldShowBackToTopButtonOpt : false;
    var isZoomEnabled = isZoomEnabledOpt !== undefined ? isZoomEnabledOpt : true;
    var applyVisibleInParent = applyVisibleInParentOpt !== undefined ? applyVisibleInParentOpt : true;
    var applyVisibleInHeader = applyVisibleInHeaderOpt !== undefined ? applyVisibleInHeaderOpt : false;
    var refreshUserSavedProducts = refreshUserSavedProductsOpt !== undefined ? refreshUserSavedProductsOpt : true;
    var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : function forcedOpenLink(param) {
        return /* ForceNoCards */ 3;
    };
    var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
    var isThemeEnabled = isThemeEnabledOpt !== undefined ? isThemeEnabledOpt : true;
    var layoutControllerHook = layoutControllerHookOpt !== undefined ? layoutControllerHookOpt : $jQE31.emptyHook;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var viewportContextValue = $aSJcu.use(undefined);
    var routerProvider = $hBcYV.useRouter(undefined);
    var match$1 = $9pMGg.use(undefined);
    var onTitleClick$1 = $2whNH.getWithDefault(onTitleClick, match$1.onSectionTitleClick);
    var onLinkClick$1 = $2whNH.getWithDefault(onLinkClick, match$1.onSectionLinkClick);
    var configLastModifiedAt = config.lastModifiedAt;
    var settings = config.settings;
    var match$2 = $lihS4.useCart(undefined);
    var cart = match$2.cart;
    var checkoutLink = settings.cart ? match$2.storeCheckoutLink : settings.checkoutLink;
    var layoutController = $jQE31.Context.use(undefined);
    var ref = $g85JO.useRef(null);
    $iv6Yc._1(layoutControllerHook, ref);
    var isMobile = viewportContextValue.isMobile;
    var activeCategoryId = $hBcYV.getListPageCategoryId(routerProvider.route);
    var favorites = $dMhWy.useFavorites(undefined);
    var match$3 = $6EwcS.use(undefined);
    var history = match$3.history;
    var match$4 = category.tabbedSubCategories;
    var tabbedSubCategories = match$4 !== undefined ? overrideTabSettings !== undefined ? overrideTabSettings : category.tabbedSubCategories : undefined;
    var enableTabs = $2whNH.isSome(tabbedSubCategories) && !$1xf0g.isQuickView(category);
    var category$1 = $g85JO.useMemo(function() {
        var match = category.socialNetworkSource;
        if (match !== undefined && match.TAG === /* Instagram */ 0) return $1xf0g.setChildren(category, $2whNH.mapWithDefault($1xf0g.getInstagramFeed(category), $1xf0g.getChildren(category), $1xf0g.getChildren));
        else return category;
    }, [
        category
    ]);
    var match$5 = $hhx0n.useTabs(enableTabs, category$1, configLastModifiedAt);
    var allTab = match$5.allTab;
    var setActiveTab = match$5.setActiveTab;
    var activeTab = match$5.activeTab;
    var getSubCategories = function getSubCategories(prependAllTabOpt, applyVisibleInParent$1, applyVisibleInHeader$1, category) {
        var prependAllTab = prependAllTabOpt !== undefined ? prependAllTabOpt : true;
        var applyVisibleInParent$2 = $2whNH.getWithDefault(applyVisibleInParent$1, applyVisibleInParent);
        var applyVisibleInHeader$2 = $2whNH.getWithDefault(applyVisibleInHeader$1, applyVisibleInHeader);
        return $i7mYY.concat($i7mYY.keepMap(prependAllTab ? [
            allTab
        ] : [], function(a) {
            return a;
        }), $i7mYY.keep($i7mYY.keep($1xf0g.getChildren(category), function(category) {
            if (applyVisibleInParent$2) return category.visibleInParent;
            else return true;
        }), function(category) {
            if (applyVisibleInHeader$2) return category.visibleInHeaderSlider;
            else return true;
        }));
    };
    var subCategories = $g85JO.useMemo(function() {
        return getSubCategories(false, undefined, undefined, category$1);
    }, [
        configLastModifiedAt,
        category$1.id,
        isMobile
    ]);
    var tabContent = $g85JO.useMemo(function() {
        return $d3YYW.fromArray($i7mYY.map(getSubCategories(undefined, false, false, category$1), function(subCategory) {
            var key = subCategory.id;
            var match = $1xf0g.ExternalConnection.getConnection(subCategory);
            var value;
            var exit = 0;
            if (match !== undefined && typeof match === "number") switch(match){
                case /* History */ 0:
                    value = {
                        TAG: /* History */ 2,
                        category: subCategory,
                        count: history.value.length
                    };
                    break;
                case /* Favorites */ 1:
                    value = {
                        TAG: /* Favorites */ 3,
                        category: subCategory,
                        count: favorites.count
                    };
                    break;
                case /* StoreCart */ 2:
                    value = {
                        TAG: /* StoreCart */ 4,
                        category: subCategory,
                        count: cart.itemCount
                    };
                    break;
            }
            else exit = 1;
            if (exit === 1) value = $1xf0g.hasSubCategories(subCategory) ? {
                TAG: /* Category */ 0,
                category: subCategory,
                subCategories: getSubCategories(false, undefined, undefined, subCategory)
            } : {
                TAG: /* Products */ 1,
                category: subCategory
            };
            return [
                key,
                value
            ];
        }));
    }, [
        configLastModifiedAt,
        category$1.id,
        isMobile
    ]);
    $3gZOF.useDelayedRegister(anchorHookResult, category$1);
    var onTabChange = $iv6Yc.__1(setActiveTab);
    var connection = $1xf0g.ExternalConnection.getConnection(category$1);
    var link = $1xf0g.Link.getCardFallbackLink(category$1);
    var content = $2whNH.flatMap(activeTab, function(activeTab) {
        return $d3YYW.get(tabContent, activeTab.id);
    });
    var contentType;
    if (content !== undefined) contentType = content;
    else switch(preferredContentType){
        case /* Products */ 0:
            contentType = {
                TAG: /* Products */ 1,
                category: category$1
            };
            break;
        case /* Category */ 1:
            contentType = {
                TAG: /* Category */ 0,
                category: category$1,
                subCategories: subCategories
            };
            break;
        case /* Favorites */ 2:
            contentType = {
                TAG: /* Favorites */ 3,
                category: category$1,
                count: favorites.count
            };
            break;
        case /* History */ 3:
            contentType = {
                TAG: /* History */ 2,
                category: category$1,
                count: history.value.length
            };
            break;
        case /* StoreCart */ 4:
            contentType = {
                TAG: /* StoreCart */ 4,
                category: category$1,
                count: cart.itemCount
            };
            break;
    }
    var contentType$1;
    if (contentType.TAG === /* Products */ 1) {
        var match$6 = contentType.category.socialNetworkSource;
        contentType$1 = match$6 !== undefined && match$6.TAG !== /* Instagram */ 0 ? {
            TAG: /* Category */ 0,
            category: $2whNH.getWithDefault($1xf0g.getTiktokFeed(category$1), category$1),
            subCategories: $2whNH.mapWithDefault($1xf0g.getTiktokFeed(category$1), subCategories, $1xf0g.getChildren)
        } : contentType;
    } else contentType$1 = contentType;
    var onLinkClick$2 = connection !== undefined && link !== undefined ? onLinkClick$1 : undefined;
    var match$7 = settings.checkoutLink;
    var linkLabel;
    linkLabel = contentType$1.TAG === /* StoreCart */ 4 && match$7 !== undefined ? "Checkout Now" : settings.openLinkLabel;
    var linkHref;
    linkHref = contentType$1.TAG === /* StoreCart */ 4 ? checkoutLink : undefined;
    var tmp = {
        category: category$1,
        linkLabel: linkLabel,
        layout: layout,
        onTitleClick: onTitleClick$1
    };
    if (linkHref !== undefined) tmp.linkHref = linkHref;
    if (customTitle !== undefined) tmp.customTitle = $loT9g.valFromOption(customTitle);
    if (onLinkClick$2 !== undefined) tmp.onLinkClick = $loT9g.valFromOption(onLinkClick$2);
    var sectionHeader = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: shouldShowHeader,
        children: /*#__PURE__*/ $g85JO.createElement($44tgL.make, tmp)
    });
    var isMkrBioContent = $2whNH.mapWithDefault(parentCategory, false, function(parent) {
        return $2whNH.isSome(parent.socialNetworkSource);
    });
    var enableScrollbar = !isMkrBioContent;
    var verticalPadding = isMkrBioContent && index === 0;
    var forcedRounded = !isMkrBioContent;
    var match$8 = category$1.categoryType;
    var content$1;
    if (typeof match$8 === "number") content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($jAQD1.make, {
        config: config,
        elementId: category$1.id
    }));
    else switch(match$8.TAG | 0){
        case /* CustomComponentSection */ 5:
            var component = match$8._0.component;
            content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($hfCPd.CustomSectionRenderer.make, {
                componentId: component.id,
                renderFallback: function renderFallback(param) {
                    return null;
                },
                props: component.props
            }));
            break;
        case /* EmbedCodeSection */ 6:
            var embed = match$8._0;
            var px = embed.size[0];
            content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($1SJOO.make, {
                style: {
                    margin: "0 auto",
                    width: px ? $ezf3v.intToPx(px._0) : "100%"
                },
                children: embed.code
            }));
            break;
        default:
            switch(contentType$1.TAG | 0){
                case /* Category */ 0:
                    var subCategories$1 = contentType$1.subCategories;
                    if (subCategories$1.length !== 0) {
                        var tmp$1 = {
                            category: contentType$1.category,
                            scrollableContainerRef: scrollableContainerRef,
                            layout: layout,
                            enableScrollbar: enableScrollbar,
                            index: index,
                            isPaddingEnabled: isPaddingEnabled,
                            verticalPadding: verticalPadding,
                            subCategories: subCategories$1,
                            forcedRounded: forcedRounded,
                            forcedOpenLink: forcedOpenLink,
                            onOverlayProductClick: match$1.onOverlayProductClick,
                            onCategoryClick: match$1.onCategoryClick,
                            onQuickViewClick: match$1.onQuickViewClick,
                            onProductClick: match$1.onProductClick
                        };
                        if (enableSmartCard !== undefined) tmp$1.enableSmartCard = $loT9g.valFromOption(enableSmartCard);
                        if (enableFirstCard !== undefined) tmp$1.enableFirstCard = $loT9g.valFromOption(enableFirstCard);
                        if (enableLastCard !== undefined) tmp$1.enableLastCard = $loT9g.valFromOption(enableLastCard);
                        if (shouldCenterSlides !== undefined) tmp$1.shouldCenterSlides = $loT9g.valFromOption(shouldCenterSlides);
                        if (priority !== undefined) tmp$1.priority = $loT9g.valFromOption(priority);
                        if (forcedSize !== undefined) tmp$1.forcedSize = $loT9g.valFromOption(forcedSize);
                        if (forcedShape !== undefined) tmp$1.forcedShape = $loT9g.valFromOption(forcedShape);
                        content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($hP9EI.make, tmp$1));
                    } else content$1 = undefined;
                    break;
                case /* Products */ 1:
                    var category$2 = contentType$1.category;
                    if ($1xf0g.hasProducts(category$2)) {
                        var tmp$2 = {
                            category: category$2,
                            scrollableContainerRef: scrollableContainerRef,
                            layout: layout,
                            isPaddingEnabled: isPaddingEnabled,
                            isZoomEnabled: isZoomEnabled,
                            forcedOpenLink: forcedOpenLink
                        };
                        if (shouldCenterSlides !== undefined) tmp$2.shouldCenterSlides = $loT9g.valFromOption(shouldCenterSlides);
                        if (enableSmartCard !== undefined) tmp$2.enableSmartCard = $loT9g.valFromOption(enableSmartCard);
                        if (enableFirstCard !== undefined) tmp$2.enableFirstCard = $loT9g.valFromOption(enableFirstCard);
                        if (enableLastCard !== undefined) tmp$2.enableLastCard = $loT9g.valFromOption(enableLastCard);
                        if (enableInlineMedia !== undefined) tmp$2.enableInlineMedia = $loT9g.valFromOption(enableInlineMedia);
                        if (priority !== undefined) tmp$2.priority = $loT9g.valFromOption(priority);
                        if (forcedSize !== undefined) tmp$2.forcedSize = $loT9g.valFromOption(forcedSize);
                        if (forcedShape !== undefined) tmp$2.forcedShape = $loT9g.valFromOption(forcedShape);
                        if (hideRelatedProductId !== undefined) tmp$2.hideRelatedProductId = $loT9g.valFromOption(hideRelatedProductId);
                        content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($d9SaG.make, tmp$2));
                    } else content$1 = undefined;
                    break;
                case /* History */ 2:
                    var category$3 = contentType$1.category;
                    if (contentType$1.count > 0 || $7bjme.equal(category$3.id, activeCategoryId)) {
                        var tmp$3 = {
                            layout: layout,
                            category: category$3,
                            isPaddingEnabled: isPaddingEnabled,
                            fixedOrder: !refreshUserSavedProducts,
                            requestType: "history"
                        };
                        if (shouldCenterSlides !== undefined) tmp$3.shouldCenterSlides = $loT9g.valFromOption(shouldCenterSlides);
                        content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($7MOac.make, tmp$3));
                    } else content$1 = undefined;
                    break;
                case /* Favorites */ 3:
                    var category$4 = contentType$1.category;
                    if (contentType$1.count > 0 || $7bjme.equal(category$4.id, activeCategoryId)) {
                        var tmp$4 = {
                            layout: layout,
                            category: category$4,
                            isPaddingEnabled: isPaddingEnabled,
                            fixedOrder: !refreshUserSavedProducts,
                            requestType: "favorites"
                        };
                        if (shouldCenterSlides !== undefined) tmp$4.shouldCenterSlides = $loT9g.valFromOption(shouldCenterSlides);
                        content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($7MOac.make, tmp$4));
                    } else content$1 = undefined;
                    break;
                case /* StoreCart */ 4:
                    var category$5 = contentType$1.category;
                    if (contentType$1.count > 0 || $7bjme.equal(category$5.id, activeCategoryId)) {
                        var tmp$5 = {
                            layout: layout,
                            category: category$5,
                            isPaddingEnabled: isPaddingEnabled,
                            fixedOrder: !refreshUserSavedProducts,
                            requestType: "cart"
                        };
                        if (shouldCenterSlides !== undefined) tmp$5.shouldCenterSlides = $loT9g.valFromOption(shouldCenterSlides);
                        content$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($7MOac.make, tmp$5));
                    } else content$1 = undefined;
                    break;
            }
    }
    var contentCategoryId;
    switch(contentType$1.TAG | 0){
        case /* Category */ 0:
        case /* Products */ 1:
        case /* History */ 2:
        case /* Favorites */ 3:
        case /* StoreCart */ 4:
            contentCategoryId = contentType$1.category.id;
            break;
    }
    var description;
    var exit = 0;
    var description$1;
    var showDescription;
    switch(contentType$1.TAG | 0){
        case /* Category */ 0:
            var match$9 = contentType$1.category;
            description$1 = match$9.description;
            showDescription = match$9.showDescription;
            exit = 1;
            break;
        case /* Products */ 1:
            var match$10 = contentType$1.category;
            description$1 = match$10.description;
            showDescription = match$10.showDescription;
            exit = 1;
            break;
        case /* History */ 2:
            var match$11 = contentType$1.category;
            description$1 = match$11.description;
            showDescription = match$11.showDescription;
            exit = 1;
            break;
        case /* Favorites */ 3:
            var match$12 = contentType$1.category;
            description$1 = match$12.description;
            showDescription = match$12.showDescription;
            exit = 1;
            break;
        case /* StoreCart */ 4:
            var match$13 = contentType$1.category;
            description$1 = match$13.description;
            showDescription = match$13.showDescription;
            exit = 1;
            break;
    }
    if (exit === 1) description = activeTab !== undefined && showDescription ? description$1 : undefined;
    var backToTopButton = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: shouldShowBackToTopButton,
        children: /*#__PURE__*/ $g85JO.createElement($e1Nsu.make, {
            scrollableContainerRef: scrollableContainerRef,
            position: "sticky"
        })
    });
    var isSectionSticky = category$1.stickySection;
    var stickyContainerStyles = isSectionSticky ? {
        position: "sticky",
        top: $ezf3v.intToPx(layoutController.state.showPrimaryNavbar ? (layoutController.state.primaryNavbarHeight + layoutController.state.toolbarHeight | 0) + layoutController.state.secondaryNavbarHeight | 0 : layoutController.state.toolbarHeight + layoutController.state.secondaryNavbarHeight | 0),
        zIndex: "1",
        transition: "top 0.3s cubic-bezier(.4,0,.2,1)"
    } : undefined;
    if (content$1 === undefined) return null;
    var tmp$6;
    tmp$6 = layout.TAG === /* SliderLayout */ 0 ? "section-content-slider" : "section-content-grid";
    var tmp$7 = {
        category: category$1,
        index: index,
        tabs: match$5.tabs,
        onTabChange: onTabChange,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: tmp$6,
            dataId: category$1.title,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                id: "sn-section-content-" + contentCategoryId
            }, $loT9g.valFromOption(content$1))
        }),
        maxWidth: $1xf0g.Layout.getMaxWidth(category$1.userSelectedLayout),
        padding: $1xf0g.Layout.getPadding(category$1.userSelectedLayout)
    };
    if (activeTab !== undefined) tmp$7.activeTab = $loT9g.valFromOption(activeTab);
    if (tabbedSubCategories !== undefined) tmp$7.settings = $loT9g.valFromOption(tabbedSubCategories);
    if (description !== undefined) tmp$7.description = description;
    var children$1 = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, sectionHeader, /*#__PURE__*/ $g85JO.createElement($hhx0n.make, tmp$7), backToTopButton, $2whNH.getWithDefault(children, null));
    var tmp$8 = {
        kind: "section",
        id: "sn-section-container-" + category$1.id,
        nodeId: category$1.id,
        role: "region",
        ariaLabel: category$1.title,
        fwdRef: $5bEXW.Ref.domRef(ref),
        category: category$1,
        children: isThemeEnabled ? /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
            initiator: "clp-section",
            reference: category$1.sectionTheme,
            className: $1TRFX.make([
                $ezf3v.prefix("group space-y-6"),
                $ezf3v.prefix("hide-on-empty"),
                $ezf3v.prefix("pt-section-padding-top pb-section-padding-bottom"),
                $ezf3v.prefix("bg-main"),
                $2whNH.getWithDefault(className, "")
            ]),
            portal: false,
            children: children$1
        }) : /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("group space-y-6"),
                $ezf3v.prefix("hide-on-empty"),
                $ezf3v.prefix("pt-section-padding-top pb-section-padding-bottom"),
                $ezf3v.prefix("bg-main"),
                $2whNH.getWithDefault(className, "")
            ])
        }, children$1)
    };
    if (stickyContainerStyles !== undefined) tmp$8.style = $loT9g.valFromOption(stickyContainerStyles);
    return /*#__PURE__*/ $g85JO.createElement($dtaxl.make, tmp$8);
}
$28c413232e8985e3$var$SectionContent.displayName = "SectionContent";
var $28c413232e8985e3$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($28c413232e8985e3$var$SectionContent);
var $28c413232e8985e3$export$aa541d093b11ace2 = $28c413232e8985e3$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("hhx0n", function(module, exports) {

$parcel$export(module.exports, "useTabs", function () { return $c94da04d6d40f49f$export$d2589202ac9c89c3; });
$parcel$export(module.exports, "make", function () { return $c94da04d6d40f49f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $lybpH = parcelRequire("lybpH");

var $dMhWy = parcelRequire("dMhWy");

var $2jMpY = parcelRequire("2jMpY");

var $5tfgg = parcelRequire("5tfgg");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $5av24 = parcelRequire("5av24");

var $eIwLU = parcelRequire("eIwLU");

var $aSJcu = parcelRequire("aSJcu");

var $2XXXw = parcelRequire("2XXXw");

var $lihS4 = parcelRequire("lihS4");

var $khAUl = parcelRequire("khAUl");

var $8E2YL = parcelRequire("8E2YL");

var $6EwcS = parcelRequire("6EwcS");
function $c94da04d6d40f49f$export$d2589202ac9c89c3(enabledOpt, category, key) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var match = $lihS4.useCart(undefined);
    var cart = match.cart;
    var favorites = $dMhWy.useFavorites(undefined);
    var match$1 = $6EwcS.use(undefined);
    var history = match$1.history;
    var match$2 = $efwy1.use(undefined);
    var namespace = match$2.namespace;
    var match$3 = $hBcYV.useRouter(undefined);
    var allTab = $g85JO.useMemo(function() {
        if (enabled) return $khAUl.getSmartCard(undefined, true, true, category);
    }, [
        category.id,
        key
    ]);
    var hasAnyItems = function hasAnyItems(category) {
        var match = $1xf0g.ExternalConnection.getConnection(category);
        if (match !== undefined && typeof match === "number") switch(match){
            case /* History */ 0:
                return history.value.length !== 0;
            case /* Favorites */ 1:
                return favorites.count > 0;
            case /* StoreCart */ 2:
                return cart.itemCount > 0;
        }
        if ($1xf0g.hasAnyItems(category)) return true;
        else return $2whNH.isSome($1xf0g.Link.getCardLink(category));
    };
    var tabs = $g85JO.useMemo(function() {
        if (enabled) return $i7mYY.keep($i7mYY.keep($i7mYY.concat($i7mYY.keepMap([
            allTab
        ], function(a) {
            return a;
        }), $1xf0g.getChildren(category)), function(category) {
            return category.visibleInMenuBar;
        }), hasAnyItems);
        else return [];
    }, [
        category.id,
        key,
        history.value,
        favorites.count,
        cart.itemCount
    ]);
    var restorationId = "tab-restoration-" + category.id;
    var restoration = $2XXXw.useScrollRestoration(restorationId);
    var getInitialTab = function getInitialTab(previousTab) {
        var i = restoration.position;
        var index;
        index = typeof i === "number" ? enabled ? 0 : undefined : i.TAG === /* Pixels */ 0 ? enabled ? 0 : undefined : enabled ? i._0 : enabled ? 0 : undefined;
        if (index === undefined) return previousTab;
        var c = $i7mYY.get($i7mYY.keep(tabs, hasAnyItems), index);
        if (c !== undefined) return c;
        else return previousTab;
    };
    var match$4 = $g85JO.useState(function() {
        return getInitialTab(undefined);
    });
    var setActiveTab = match$4[1];
    var activeTab = match$4[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setActiveTab, getInitialTab);
    }, [
        key,
        $hBcYV.toString(match$3.route)
    ]);
    var setActiveTab$1 = $g85JO.useCallback(function(category) {
        var index = $i7mYY.getIndexBy(tabs, function(category0) {
            return category0.id === category.id;
        });
        if (index !== undefined) $2XXXw.setCurrentScroll(namespace, restorationId, {
            TAG: /* Index */ 1,
            _0: index
        });
        $iv6Yc._1(setActiveTab, function(param) {
            return category;
        });
    }, [
        tabs,
        setActiveTab
    ]);
    return $g85JO.useMemo(function() {
        return {
            activeTab: activeTab,
            setActiveTab: setActiveTab$1,
            allTab: allTab,
            tabs: tabs
        };
    }, [
        activeTab,
        setActiveTab$1,
        allTab,
        tabs,
        key
    ]);
}
var $c94da04d6d40f49f$export$62680b65e63e14ec = {
    layout: /* Labels */ 0,
    size: /* Medium */ 1,
    position: /* Top */ 0,
    align: /* Left */ 0
};
function $c94da04d6d40f49f$var$SectionTabs(Props) {
    var category = Props.category;
    var index = Props.index;
    var tabs = Props.tabs;
    var activeTab = Props.activeTab;
    var settingsOpt = Props.settings;
    var onTabChange = Props.onTabChange;
    var description = Props.description;
    var children = Props.children;
    var maxWidth = Props.maxWidth;
    var padding = Props.padding;
    var settings = settingsOpt !== undefined ? settingsOpt : $c94da04d6d40f49f$export$62680b65e63e14ec;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var isPLP = $lybpH.useIsPLP(undefined);
    $8E2YL.use(undefined);
    var onChange = function onChange(categoryId) {
        var category = $i7mYY.getBy(tabs, function(category) {
            return category.id === categoryId;
        });
        if (category !== undefined) return $2whNH.forEach(onTabChange, function(fn) {
            $iv6Yc._1(fn, category);
        });
    };
    var match$1 = settings.layout;
    var layout;
    switch(match$1){
        case /* Labels */ 0:
            layout = /* Labels */ 0;
            break;
        case /* PillsWithLabel */ 1:
            layout = /* PillsWithLabel */ 2;
            break;
        case /* PillsWithIcon */ 2:
            layout = /* PillsWithIcon */ 3;
            break;
        case /* PillsWithRoundedIcon */ 3:
            layout = /* PillsWithRoundedIcon */ 4;
            break;
    }
    var match$2 = settings.size;
    var match$3 = category.socialNetworkSource;
    var size = match$3 !== undefined ? /* Small */ 0 : match$2;
    var match$4 = settings.position;
    var match$5 = category.socialNetworkSource;
    var indicatorPosition = match$4 || match$5 !== undefined ? /* Top */ 0 : /* Bottom */ 1;
    var match$6 = settings.align;
    var centered = match$6 === 1;
    var match$7 = category.socialNetworkSource;
    var border = match$7 !== undefined ? index === 0 ? /* BorderNone */ 0 : /* BorderTop */ 2 : /* BorderBottom */ 1;
    var match$8 = category.socialNetworkSource;
    var indicatorThickness = match$8 !== undefined ? /* Sm */ 1 : /* Normal */ 0;
    var match$9 = category.socialNetworkSource;
    var indicatorEnabled = match$9 !== undefined ? index !== 0 : true;
    var match$10 = category.socialNetworkSource;
    var height = match$10 !== undefined ? /* Lg */ 1 : /* Normal */ 0;
    var match$11 = category.socialNetworkSource;
    var gap = match$11 !== undefined ? isMobile ? /* Lg */ 1 : /* Xl */ 2 : /* Normal */ 0;
    var style = $2whNH.map(maxWidth, function(maxWidth) {
        return {
            marginRight: "auto",
            marginLeft: "auto",
            maxWidth: $ezf3v.intToPx(maxWidth)
        };
    });
    var partial_arg = true;
    var items = $i7mYY.map(tabs, function(param) {
        return $5tfgg.fromCategory(partial_arg, param);
    });
    var match$12 = items.length;
    var items$1 = match$12 !== 1 ? isPLP ? [] : items : [];
    var renderDescription = function renderDescription(param) {
        var descriptionPaddingCn = padding !== undefined ? "" : isMobile ? "px-4" : "px-8";
        var descriptionPaddingStyle = padding !== undefined ? {
            paddingRight: $ezf3v.intToPx(padding),
            paddingLeft: $ezf3v.intToPx(padding)
        } : undefined;
        var match = settings.align;
        var descriptionAlignmentCn;
        switch(match){
            case /* Left */ 0:
                descriptionAlignmentCn = "text-left";
                break;
            case /* Center */ 1:
                descriptionAlignmentCn = "text-center";
                break;
            case /* Right */ 2:
                descriptionAlignmentCn = "text-right";
                break;
        }
        var match$1 = settings.align;
        var maxWidthCn = match$1 !== 0 ? "" : "max-w-3xl";
        return $2whNH.mapWithDefault(description, null, function(description) {
            var tmp = {
                className: $ezf3v.prefix($1TRFX.make([
                    "text-lg text-secondary select-text",
                    "py-2",
                    maxWidthCn,
                    descriptionAlignmentCn,
                    descriptionPaddingCn
                ]))
            };
            if (descriptionPaddingStyle !== undefined) tmp.style = $loT9g.valFromOption(descriptionPaddingStyle);
            return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
                lines: 2,
                dataTestId: "category-description",
                children: $iv6Yc._1($2jMpY.stripHTML, description)
            }));
        });
    };
    var tabs$1;
    if (items$1.length !== 0) {
        var tmp = {};
        if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
        var tmp$1 = {
            items: items$1,
            layout: layout,
            size: size,
            dataTestId: "clp-sectionheader-tab",
            centered: centered,
            className: $ezf3v.prefix("text-secondary"),
            onChange: onChange,
            border: border,
            indicatorEnabled: indicatorEnabled,
            indicatorThickness: indicatorThickness,
            indicatorPosition: indicatorPosition,
            height: height,
            gap: gap
        };
        var tmp$2 = $2whNH.map(activeTab, function(tab) {
            return tab.id;
        });
        if (tmp$2 !== undefined) tmp$1.activeValue = $loT9g.valFromOption(tmp$2);
        if (padding !== undefined) tmp$1.padding = padding;
        tabs$1 = /*#__PURE__*/ $g85JO.createElement("div", tmp, settings.position === /* Bottom */ 1 ? renderDescription(undefined) : null, /*#__PURE__*/ $g85JO.createElement($eIwLU.make, tmp$1), settings.position === /* Top */ 0 ? renderDescription(undefined) : null);
    } else tabs$1 = null;
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, settings.position === /* Top */ 0 ? tabs$1 : null, children, settings.position === /* Bottom */ 1 ? tabs$1 : null);
}
$c94da04d6d40f49f$var$SectionTabs.displayName = "SectionTabs";
var $c94da04d6d40f49f$export$dd44f18ab656f3bb = $c94da04d6d40f49f$var$SectionTabs;
 /* react Not a pure module */ 
});

parcelRegister("1SJOO", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $15ee60354b995a82$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $5alaa = parcelRequire("5alaa");

var $75ZqT = parcelRequire("75ZqT");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $bBMv4 = parcelRequire("bBMv4");

var $4QdUt = parcelRequire("4QdUt");
function $15ee60354b995a82$var$WrapInIframe(Props) {
    var style = Props.style;
    var children = Props.children;
    var randId = $g85JO.useRef(String($5alaa.random_int(1000, 9999))).current;
    var match = $g85JO.useState(function() {});
    var setHeight = match[1];
    var height = match[0];
    $g85JO.useEffect(function() {
        var onResize = function onResize($$event) {
            var _type = $$event.data.type;
            var height = $$event.data.height;
            var error = $$event.data.error;
            if (_type !== undefined) {
                if (_type === "maker_nav_iframe_resize_" + randId) return $iv6Yc._1(setHeight, function(previous) {
                    return $2whNH.orElse(height, previous);
                });
                else if (_type === "maker_nav_iframe_error_" + randId) {
                    $2whNH.map(error, function(error) {
                        return $4QdUt.jsError1($75ZqT.$$Error.fromRescriptWithNewMessage($bBMv4.internalToOCamlException(error), "Error raised in iframe embed: " + error.message));
                    });
                    return;
                } else return;
            }
        };
        window.addEventListener("message", onResize);
        return function(param) {
            window.removeEventListener("message", onResize);
        };
    }, []);
    var style$1 = $g85JO.useMemo(function() {
        var styleWithHeight = height !== undefined ? {
            height: $ezf3v.intToPx(height)
        } : {};
        var style$2 = style !== undefined ? $loT9g.valFromOption(style) : {};
        return Object.assign({}, style$2, styleWithHeight);
    }, [
        style,
        height
    ]);
    var srcDoc = '<html style="overflow:hidden">\n  <head>\n    <style>body{margin:0}</style>\n    <script>window.onerror = (message, file, line, column, errorObj) => {\n      window.parent.postMessage({\n        type: \'maker_nav_iframe_error_' + randId + "',\n        error: {\n          message,\n          file,\n          line,\n          column,\n          errorObj\n        },\n        '*'\n      })\n    }</script>\n    <script>document.addEventListener('click', e => (e.target.closest('a')?.href && (e.preventDefault(), window.top.location.href = e.target.closest('a').href)));</script>\n    <script>window.addEventListener('message', function(event) { if (window !== window.parent) { window.parent.postMessage(event.data, '*') }})</script>\n    <script>(function() {\n      const sendResize = () => {\n        const height = document.documentElement.offsetHeight || document.body.offsetHeight;\n        if (!height) {\n          return;\n        }\n\n        window.parent.postMessage(\n          {\n            type: 'maker_nav_iframe_resize_" + randId + "',\n            height\n          },\n          '*'\n        );\n      };\n\n      window.addEventListener('load', () => {\n        new ResizeObserver(sendResize).observe(document.body);\n        sendResize();\n      });\n      window.addEventListener('DOMContentLoaded', sendResize);\n    })();</script>\n  </head>\n  <body>" + children + "</body>\n</html>";
    return /*#__PURE__*/ $g85JO.createElement("iframe", {
        style: style$1,
        srcDoc: srcDoc
    });
}
$15ee60354b995a82$var$WrapInIframe.displayName = "WrapInIframe";
var $15ee60354b995a82$export$dd44f18ab656f3bb = $15ee60354b995a82$var$WrapInIframe;
 /* react Not a pure module */ 
});

parcelRegister("44tgL", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $2f6e3d6ac742a9dd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $1xf0g = parcelRequire("1xf0g");

var $2jMpY = parcelRequire("2jMpY");

var $7lklg = parcelRequire("7lklg");

var $gCzsf = parcelRequire("gCzsf");

var $hBcYV = parcelRequire("hBcYV");

var $dtaxl = parcelRequire("dtaxl");

var $k0ukS = parcelRequire("k0ukS");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");
function $2f6e3d6ac742a9dd$var$SectionHeader(Props) {
    var category = Props.category;
    var linkLabel = Props.linkLabel;
    var linkHref = Props.linkHref;
    var showArrowOpt = Props.showArrow;
    var openLinkInNewTabOpt = Props.openLinkInNewTab;
    var minimalOpt = Props.minimal;
    var flushedOpt = Props.flushed;
    var overrideTitle = Props.overrideTitle;
    var renderTitle = Props.renderTitle;
    var renderDescription = Props.renderDescription;
    var contentBeforeTitle = Props.contentBeforeTitle;
    var contentAfterTitle = Props.contentAfterTitle;
    var layout = Props.layout;
    var customTitle = Props.customTitle;
    var onTitleClick = Props.onTitleClick;
    var onLinkClick = Props.onLinkClick;
    var showArrow = showArrowOpt !== undefined ? showArrowOpt : true;
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var minimal = minimalOpt !== undefined ? minimalOpt : false;
    var flushed = flushedOpt !== undefined ? flushedOpt : false;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var match$1 = $aSJcu.use(undefined);
    var match$2 = $hBcYV.useRouter(undefined);
    var count = $2whNH.map($1xf0g.ExternalConnection.getStoreCategoryConnection(category), function(connection) {
        return connection.count;
    });
    var isConnected = $1xf0g.ExternalConnection.isConnectedToStoreCategory(category);
    var isCategoryActive = $7bjme.equal({
        TAG: /* Category */ 0,
        _0: category.id
    }, match$2.listPageType);
    var onTitleClick$1 = onTitleClick !== undefined && (!isCategoryActive || isConnected) ? function onTitleClick$1(e) {
        $iv6Yc._1(onTitleClick, category);
    } : undefined;
    var onLinkClick$1 = onLinkClick !== undefined ? function onLinkClick$1(param) {
        $iv6Yc._1(onLinkClick, category);
    } : undefined;
    var match$3 = $1xf0g.Link.getCardFallbackLink(category);
    var href = linkHref !== undefined ? linkHref : match$3 !== undefined && match$3.TAG === /* URL */ 0 && $2whNH.isNone(onLinkClick$1) ? match$3._0 : undefined;
    var canClickTitle = $2whNH.isSome(onTitleClick$1);
    var canClickLink = $2whNH.isSome(onLinkClick$1) || $2whNH.isSome(href);
    var showArrow$1 = showArrow && canClickTitle;
    var onLinkClick$2 = function onLinkClick$2(e) {
        $iv6Yc.app(trackEvent, [
            "slider:see all link",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        $2whNH.forEach(onLinkClick$1, function(callback) {
            $iv6Yc._1(callback, undefined);
        });
    };
    var linkTextSize = match$1.breakpoint >= 2 ? "text-xl" : "text-lg";
    var headingClassName = $ezf3v.prefix($1TRFX.make([
        "group-2 inline-flex flex-col",
        canClickTitle ? "cursor-pointer" : ""
    ]));
    var renderHeading = function renderHeading(param) {
        var tmp = {
            minimal: minimal,
            showArrow: showArrow$1,
            text: $2whNH.getWithDefault(overrideTitle, category.title)
        };
        if (onTitleClick$1 !== undefined) tmp.onClick = $loT9g.valFromOption(onTitleClick$1);
        return /*#__PURE__*/ $g85JO.createElement($7lklg.make, tmp);
    };
    var renderDescription$1 = renderDescription !== undefined ? renderDescription : function renderDescription$1(param) {
        var description = category.description;
        if (description !== undefined && !minimal && category.showDescription) return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "category-description",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "line-clamp-2",
                    "select-text",
                    "text-lg",
                    "text-secondary",
                    "mt-2",
                    "max-w-3xl"
                ]))
            }, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
                className: "section__description",
                children: $iv6Yc._1($2jMpY.stripHTML, description)
            }))
        });
        else return null;
    };
    var renderTitle$1 = renderTitle !== undefined ? renderTitle : function renderTitle$1(param) {
        return /*#__PURE__*/ $g85JO.createElement($dtaxl.make, {
            kind: "section-title",
            nodeId: category.id,
            className: headingClassName,
            category: category,
            children: renderHeading(undefined)
        });
    };
    var renderLink = function renderLink(param) {
        if (linkLabel !== undefined && linkLabel !== "" && canClickLink) {
            var tmp = {
                children: /*#__PURE__*/ $g85JO.createElement("span", {
                    className: $ezf3v.prefix($1TRFX.make([
                        "flex items-center",
                        linkTextSize
                    ]))
                }, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
                    className: "section__link",
                    children: null
                }, linkLabel, $2whNH.mapWithDefault(count, "", function(c) {
                    return " (" + String(c) + ")";
                }))),
                openLinkInNewTab: openLinkInNewTab,
                dataTestId: "clp-sectionheader-link",
                onClick: onLinkClick$2
            };
            if (href !== undefined) tmp.href = $loT9g.valFromOption(href);
            return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex-grow flex justify-end font-button")
            }, /*#__PURE__*/ $g85JO.createElement($tUpyX.make, tmp));
        }
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-grow flex justify-end")
        });
    };
    var style = $2whNH.map(layout, function(layout) {
        if (layout.TAG === /* SliderLayout */ 0) {
            var slider = layout._0;
            var tmp = {};
            var tmp$1 = $2whNH.map(slider.maxWidth, $ezf3v.intToPx);
            if (tmp$1 !== undefined) tmp.maxWidth = tmp$1;
            var tmp$2 = $2whNH.map(slider.padding, $ezf3v.intToPx);
            if (tmp$2 !== undefined) tmp.paddingRight = tmp$2;
            var tmp$3 = $2whNH.map(slider.padding, $ezf3v.intToPx);
            if (tmp$3 !== undefined) tmp.paddingLeft = tmp$3;
            return tmp;
        }
        var grid = layout._0;
        var tmp$4 = {};
        var tmp$5 = $2whNH.map(grid.maxWidth, $ezf3v.intToPx);
        if (tmp$5 !== undefined) tmp$4.maxWidth = tmp$5;
        var tmp$6 = $2whNH.map(grid.padding, $ezf3v.intToPx);
        if (tmp$6 !== undefined) tmp$4.paddingRight = tmp$6;
        var tmp$7 = $2whNH.map(grid.padding, $ezf3v.intToPx);
        if (tmp$7 !== undefined) tmp$4.paddingLeft = tmp$7;
        return tmp$4;
    });
    if (customTitle !== undefined) return $loT9g.valFromOption(customTitle);
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            "flex flex-col w-full mx-auto",
            flushed ? "" : match$1.isMobile ? "px-4" : "px-8"
        ]))
    };
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: category.showTitle && ($1xf0g.hasAnyItems(category) || $2whNH.isSome(overrideTitle)),
        children: /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
            className: "section__title-box",
            children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                dataTestId: "clp-sectionheader",
                dataSectionId: category.id,
                children: /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex flex-col flex-grow"),
                    role: "heading"
                }, /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex space-x-3 w-full items-center justify-end")
                }, /*#__PURE__*/ $g85JO.createElement($2ZaET.WhenSome.make, {
                    children: contentBeforeTitle
                }), $iv6Yc._1(renderTitle$1, undefined), renderLink(undefined), /*#__PURE__*/ $g85JO.createElement($2ZaET.WhenSome.make, {
                    children: contentAfterTitle
                })), $iv6Yc._1(renderDescription$1, undefined)))
            })
        })
    });
}
$2f6e3d6ac742a9dd$var$SectionHeader.displayName = "SectionHeader";
var $2f6e3d6ac742a9dd$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($2f6e3d6ac742a9dd$var$SectionHeader);
 /* make Not a pure module */ 
});
parcelRegister("7lklg", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $016132adc583f41e$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $5PS1O = parcelRequire("5PS1O");

var $gCzsf = parcelRequire("gCzsf");

var $k0ukS = parcelRequire("k0ukS");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");
function $016132adc583f41e$var$SectionTitle(Props) {
    var minimalOpt = Props.minimal;
    var showArrowOpt = Props.showArrow;
    var text = Props.text;
    var onClick = Props.onClick;
    var minimal = minimalOpt !== undefined ? minimalOpt : true;
    var showArrow = showArrowOpt !== undefined ? showArrowOpt : false;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var titleTextSize = match.breakpoint >= 2 ? "text-3xl" : $1TRFX.make([
        minimal ? "text-xl" : "text-2xl"
    ]);
    var renderArrow = function renderArrow(param) {
        return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: showArrow,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("translate-x-1 group-2-hover:translate-x-2 transform-gpu transition duration-300")
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "transform-gpu transition duration-300 group-hover:duration-150 text-accent",
                    isMobile ? "" : "opacity-0 -translate-x-0 group-hover:opacity-100 group-hover:translate-x-1/2"
                ]))
            }, /*#__PURE__*/ $g85JO.createElement($5PS1O.make, {
                className: $ezf3v.prefix("w-4 h-4"),
                strokeWidth: "5"
            })))
        });
    };
    var tmp = {
        "aria-level": 2,
        className: $ezf3v.prefix("inline-flex items-center gap-1 flex-grow-0"),
        role: "button"
    };
    var tmp$1 = $2whNH.map(onClick, function(param) {
        return 0;
    });
    if (tmp$1 !== undefined) tmp.tabIndex = $loT9g.valFromOption(tmp$1);
    if (onClick !== undefined) tmp.onClick = $loT9g.valFromOption(onClick);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "clp-sectionheader-title",
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                minimal ? "line-clamp-1" : "line-clamp-2",
                "font-semibold text-primary no-underline",
                "font-heading",
                titleTextSize
            ]))
        }, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
            className: "section__title",
            children: text
        })), renderArrow(undefined))
    });
}
$016132adc583f41e$var$SectionTitle.displayName = "SectionTitle";
var $016132adc583f41e$export$dd44f18ab656f3bb = $016132adc583f41e$var$SectionTitle;
 /* react Not a pure module */ 
});



parcelRegister("insiF", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $d61053c37f0227fa$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $d61053c37f0227fa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $7tAuM = parcelRequire("7tAuM");

var $d61053c37f0227fa$var$component = (0, $7tAuM.lazy)(function() {
    return (parcelRequire("aUETq"));
});
function $d61053c37f0227fa$var$Slider_Lazy(Props) {
    var fallbackOpt = Props.fallback;
    var fallback = fallbackOpt !== undefined ? $loT9g.valFromOption(fallbackOpt) : null;
    var element = /*#__PURE__*/ $g85JO.createElement($d61053c37f0227fa$var$component, Props);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Suspense, {
        children: element,
        fallback: fallback
    });
}
$d61053c37f0227fa$var$Slider_Lazy.displayName = "Slider_Lazy";
var $d61053c37f0227fa$export$513ccb98c53b8039 = $d61053c37f0227fa$var$component.preload;
var $d61053c37f0227fa$export$dd44f18ab656f3bb = $d61053c37f0227fa$var$Slider_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("aUETq", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5G2Uq"))
]).then(function() {
    return parcelRequire("khdgl");
});

});


parcelRegister("bbixw", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $823f1a66b75c81dd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $11Dnx = parcelRequire("11Dnx");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $hBcYV = parcelRequire("hBcYV");

var $4QdUt = parcelRequire("4QdUt");
var $823f1a66b75c81dd$export$e575061ef2a070eb = {
    contents: {}
};
function $823f1a66b75c81dd$var$ErrorReporter(Props) {
    var error = Props.error;
    var displayMessage = Props.displayMessage;
    var extraInfo = Props.extraInfo;
    var retry = Props.retry;
    var redirect = Props.redirect;
    var canRenderOnLiveOpt = Props.canRenderOnLive;
    var absoluteOpt = Props.absolute;
    var reportEvery = Props.reportEvery;
    var canRenderOnLive = canRenderOnLiveOpt !== undefined ? canRenderOnLiveOpt : false;
    var absolute = absoluteOpt !== undefined ? absoluteOpt : false;
    var match = $hBcYV.useRouter(undefined);
    var previewMode = match.previewMode;
    var isPreviewMode = $7bjme.notequal(previewMode, /* PreviewLive */ 1) && previewMode !== undefined;
    var displayMessage$1;
    var exit = 0;
    if (displayMessage !== undefined && (error.RE_EXN_ID === $4QdUt.LogicalError || error.RE_EXN_ID === $4QdUt.LogicalErrorUnreported)) displayMessage$1 = displayMessage;
    else exit = 1;
    if (exit === 1) displayMessage$1 = error.RE_EXN_ID === $2gEz2.NetworkError ? "There appears to be a problem with your internet connection" : displayMessage !== undefined || !(error.RE_EXN_ID === $4QdUt.LogicalError || error.RE_EXN_ID === $4QdUt.LogicalErrorUnreported) ? "An unexpected error has occurred." : error._1;
    var getCount = function getCount(param) {
        return $2whNH.getWithDefault($d3YYW.get($823f1a66b75c81dd$export$e575061ef2a070eb.contents, displayMessage$1), 0);
    };
    var incrementCounter = function incrementCounter(param) {
        if (reportEvery !== undefined) {
            $823f1a66b75c81dd$export$e575061ef2a070eb.contents[displayMessage$1] = getCount(undefined) >= reportEvery ? 0 : getCount(undefined) + 1 | 0;
            return;
        }
    };
    $g85JO.useEffect(function() {
        var currentCount = getCount(undefined);
        incrementCounter(undefined);
        console.error(error);
        if (isPreviewMode) return;
        if (error.RE_EXN_ID === $2gEz2.NetworkError || error.RE_EXN_ID === $4QdUt.LogicalErrorUnreported || !(error.RE_EXN_ID === $4QdUt.LogicalError && currentCount === 0)) Promise.resolve(undefined);
        else $4QdUt.error3(error, error._1, extraInfo);
        var timeout = redirect !== undefined ? $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(redirect, undefined);
        }, 0)) : undefined;
        return function(param) {
            $2whNH.forEach(timeout, function(id) {
                clearTimeout(id);
            });
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setRetrying = match$1[1];
    var retrying = match$1[0];
    var onClickRetry = $2whNH.map(retry, function(retry, param) {
        $iv6Yc._1(setRetrying, function(param) {
            return true;
        });
        var __x = $iv6Yc._1(retry, undefined);
        var __x$1 = $11Dnx.then_(function(param) {
            $iv6Yc._1(setRetrying, function(param) {
                return false;
            });
            return Promise.resolve(undefined);
        }, __x);
        $11Dnx.$$catch(function(param) {
            $iv6Yc._1(setRetrying, function(param) {
                return false;
            });
            return Promise.resolve(undefined);
        }, __x$1);
    });
    var renderRetry = function renderRetry(param) {
        return $2whNH.mapWithDefault(onClickRetry, null, function(onClickRetry) {
            return /*#__PURE__*/ $g85JO.createElement("button", {
                className: $ezf3v.prefix($1TRFX.make([
                    "text-gray-800 px-2 py-1 border border-solid border-gray-200",
                    retrying ? "bg-gray-300" : "bg-white"
                ])),
                disabled: retrying,
                onClick: function onClick(param) {
                    $iv6Yc._1(onClickRetry, undefined);
                }
            }, "Retry");
        });
    };
    var renderExit = function renderExit(param) {
        if (redirect !== undefined) return /*#__PURE__*/ $g85JO.createElement("button", {
            className: $ezf3v.prefix($1TRFX.make([
                "text-gray-800 px-2 py-1 border border-solid border-gray-200 bg-white"
            ])),
            onClick: function onClick(param) {
                $iv6Yc._1(redirect, undefined);
            }
        }, "Back");
        else return null;
    };
    if (isPreviewMode || canRenderOnLive) return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            absolute ? "absolute inset-0" : "relative",
            "flex flex-col items-center justify-center bg-gray-50 text-gray-800 space-y-6"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex items-center justify-center h-12 w-12 rounded-full bg-white-200 text-gray-500")
    }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilExclamationTriangle.make, {})), /*#__PURE__*/ $g85JO.createElement("div", undefined, displayMessage$1), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("space-x-4")
    }, renderRetry(undefined), renderExit(undefined)), canRenderOnLive ? null : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("mt-8 text-sm justify-center text-center")
    }, /*#__PURE__*/ $g85JO.createElement("div", undefined, "Customers will never see this page."), /*#__PURE__*/ $g85JO.createElement("div", undefined, "It is only visible in preview.")));
    else return null;
}
$823f1a66b75c81dd$var$ErrorReporter.displayName = "ErrorReporter";
var $823f1a66b75c81dd$export$dd44f18ab656f3bb = $823f1a66b75c81dd$var$ErrorReporter;
 /* SWR Not a pure module */ 
});
parcelRegister("11Dnx", function(module, exports) {

$parcel$export(module.exports, "then_", function () { return $0bf46e3d3223d8dd$export$b96ad11c1bfbed03; });
$parcel$export(module.exports, "$$catch", function () { return $0bf46e3d3223d8dd$export$e62bb7a22f80ae34; });

var $iv6Yc = parcelRequire("iv6Yc");
function $0bf46e3d3223d8dd$export$b96ad11c1bfbed03(arg1, obj) {
    return obj.then($iv6Yc.__1(arg1));
}
function $0bf46e3d3223d8dd$export$e62bb7a22f80ae34(arg1, obj) {
    return obj.catch($iv6Yc.__1(arg1));
}
 /* No side effect */ 
});


})();
//# sourceMappingURL=SectionContent.bs.ee2da25b.js.map
